import { useNode } from "@craftjs/core";
import React, { useContext, useEffect, useState } from "react";
import { PostDateSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import customDateFormat from "dateformat";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraPreviewContext } from "../../post-preview/context";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const PostDate = (props) => {
  const previewContext = useContext(GrigoraPreviewContext);
  const { domain, cmsPosts } = useContext(GrigoraDashboardContext) ?? {};

  const {
    id,
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  var {
    dateFormat = "dd/mm/yyyy",
    date,
    customDate,
    prefix,
    suffix,
    linkPost,
    openInNewTab,
    link = "#",
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-post-date": true,
      [`post-date-${id}`]: id,
    },
    blockProps.className,
  );

  // const DateObject = new Date(
  //   previewContext?.postData?.first_published
  //     ? previewContext?.postData?.first_published * 1000
  //     : cmsPosts?.[0]?.first_published * 1000
  //     ? cmsPosts?.[0]?.first_published * 1000
  //     : date
  //     ? date
  //     : Date.now(),
  // );

  const [currentDate, setCurrentDate] = useState(
    previewContext?.postData?.first_published
      ? new Date(previewContext?.postData?.first_published * 1000)
      : date
      ? new Date(date)
      : cmsPosts?.[0]?.first_published
      ? new Date(cmsPosts?.[0]?.first_published * 1000)
      : Date.now(),
  );

  useEffect(() => {
    if (selected) {
      return;
    }
  }, [selected]);

  function parseDate() {
    var parsedDate = "";
    if (dateFormat === "custom") {
      parsedDate = customDateFormat(currentDate, customDate);
    } else if (dateFormat != undefined)
      parsedDate = customDateFormat(currentDate, dateFormat);
    else {
      parsedDate = currentDate;
    }
    return parsedDate;
  }

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      onClick={() => selected}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__PostDate(id, props)}`}</style>
      {linkPost ? (
        <a
          onClick={(e) => e.preventDefault()}
          target={`${openInNewTab == true ? "_blank" : "_self"}`}
          href={`https://${domain}/${cmsPosts?.[0]?.slug}`}
        >
          {prefix && <span className="prefix">{prefix}&nbsp;</span>}
          <time>{parseDate()}&nbsp;</time>
          {suffix && <span className="suffix">{suffix}</span>}
        </a>
      ) : (
        <>
          {prefix && <span className="prefix">{prefix}&nbsp;</span>}
          <time>{parseDate()}&nbsp;</time>
          {suffix && <span className="suffix">{suffix}</span>}
        </>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
PostDate.displayName = "PostDate";

PostDate.craft = {
  name: "Post Date",
  props: {},
  related: {
    settings: PostDateSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "cms",
  },
  custom: {
    name: "Post Date",
    slug: "grigora/post-date",
  },
};
